// Need to use the React-specific entry point to import createApi

import { baseApi } from "./baseApi";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const customerApi = baseApi.injectEndpoints({
  // reducerPath: "customerApi",

  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    getAllCustomer: builder.query({
      query: (query) => {
        const queryString = new URLSearchParams(query).toString();
        return {
          url: `customers`,
          params: queryString,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllCustomerQuery } = customerApi;
